import React from 'react';
import './AILimitDialog.css';

const AILimitDialog = ({ isOpen, onClose, limitInfo }) => {
  if (!isOpen || !limitInfo) return null;

  const handleAction = () => {
    if (limitInfo.action === 'upgrade_to_pro' || limitInfo.action === 'upgrade_to_agency') {
      // Open pricing page
      window.electronAPI.openExternal('https://pixlsizer.com/#pricing');
    } else if (limitInfo.action === 'buy_credits') {
      // Open credits page (future implementation)
      window.electronAPI.openExternal('https://pixlsizer.com/credits');
    }
    onClose();
  };

  const getActionText = () => {
    if (limitInfo.action === 'upgrade_to_pro') {
      return 'Upgrade to Pro';
    } else if (limitInfo.action === 'upgrade_to_agency') {
      return 'Upgrade to Agency';
    } else {
      return 'Buy Additional Credits';
    }
  };

  return (
    <div className="dialog-overlay" onClick={onClose}>
      <div className="dialog-container glass-card" onClick={(e) => e.stopPropagation()}>
        <div className="dialog-header">
          <h2>AI Usage Limit Reached</h2>
        </div>
        <div className="dialog-content">
          <p>{limitInfo.message}</p>
          {(limitInfo.tier === 'agency' || limitInfo.tier === 'partner') && (
            <p className="dialog-note">
              Additional credit packs will be available soon. Contact support@pixlevents.com for immediate assistance.
            </p>
          )}
        </div>
        <div className="dialog-actions">
          <button className="glass-button glass-button-secondary" onClick={onClose}>
            Close
          </button>
          <button className="glass-button glass-button-primary" onClick={handleAction}>
            {getActionText()}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AILimitDialog;